import { render, staticRenderFns } from "./cskh-detail.vue?vue&type=template&id=015989f6&scoped=true"
import script from "./cskh-detail.vue?vue&type=script&lang=js"
export * from "./cskh-detail.vue?vue&type=script&lang=js"
import style0 from "./cskh-detail.vue?vue&type=style&index=0&id=015989f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015989f6",
  null
  
)

export default component.exports